import { makeStyles, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';

export const useStyles = makeStyles(() => ({
  iconButton: {
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRadius: '5px',
    margin: '12px -4px 12px 24px',
    width: '135px',
    height: '32px',
    color: 'rgba(44, 45, 62, 0.8)',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    textTransform: 'none',
    lineHeight: '14px',
    '&:disabled': {
      color: 'theme.palette.grey[900]',
      cursor: 'not-allowed',
      pointerEvents: 'all',
      '& path': {
        fill: 'gray',
      },
    },
  },
  iconButtonContrast: {
    '&:disabled': {
      '& path': {
        fill: 'white',
      },
    },
  },
  downloadIcon: {
    width: '13px',
    height: '13px',
  },
  buttonOutline: {
    display: 'flex',
    flexDirection: 'row',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRadius: '5px',
    margin: '12px 0px 12px 12px',
    width: '125px',
    height: '30px',
    color: '#FFFFFF',
  },
  page: {
    maxWidth: '1040px',
  },
  infoMessage: {
    fontFamily: 'Roboto',
    textAlign: 'center',
    height: '42px',
    fontWeight: 700,
    marginTop: '20px',
  },
  nameText: {
    fontFamily: 'Roboto',
    textAlign: 'center',
    marginBottom: '30px',
  },
}));

export const CancelButton = withStyles(() => ({
  root: {
    width: '103px',
    padding: '0px 0px 0px 0px',
    height: '42px',
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    marginLeft: '79px',
    marginBottom: '35px',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
  },
}))(Button);

export const ConfirmButton = withStyles(() => ({
  root: {
    position: 'relative',
    marginBottom: '10px',
    marginLeft: '-10px',
    marginRight: '104px',
    width: '145px',
    padding: '0px 0px 0px 0px',
    height: '42px',
    border: 'solid 1px #3C419A',
    color: '#FFFFFF',
    backgroundColor: '#3C419A',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#3C419A',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
    '&:disabled': {
      backgroundColor: '#2C2D3E4D',
      color: '#FFFFFF',
      border: 'none',
    },
  },
}))(Button);
